import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TaskCaseService } from 'src/app/modules/case/services/taskCase.service';
import { InteraccionRedesSociales } from '../../../../interfaces/interaccion-redes-sociales';
import { CaseRecordService } from 'src/app/modules/case/services/case-record.service';
import { CasesService } from 'src/app/core/services/cases.service';

@Component({
  selector: 'app-caso-robo-hurto',
  templateUrl: './caso-robo-hurto.component.html',
  styleUrls: ['./caso-robo-hurto.component.scss'],
})
export class CasoRoboHurtoComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  displayedColumns: string[] = ['fecha', 'observacion'];
  dataSource = new MatTableDataSource<any>();
  tableValues: any[] = [];

  formTable: FormGroup;
  form: FormGroup;
  submit = false;
  submitFile = false;
  file: File | null;

  @Input() data: { task: any };

  constructor(
    private fb: FormBuilder,
    public taskCaseService: TaskCaseService,
    private caseRecordService: CaseRecordService,
    private caseService: CasesService
  ) {}
  icase;
  get status() {
    return this.icase?.status == 'archived';
  }
  ngOnInit(): void {
    let caseId: any;
    if (typeof this.data.task.case == 'object') {
      caseId = this.data.task.case._id;
    } else if (typeof this.data.task.case == 'string') {
      caseId = this.data.task.case;
    }

    this.caseService.getCase(caseId).subscribe((res) => {
      this.icase = res;
    });
    const { task } = this.data;
    const values = task.data ? task.data : [];

    this.tableValues = values ? values : [];
    this.formTable = this.fb.group({
      fecha: ['', [Validators.required]],
      observacion: ['', [Validators.required]],
    });
    this.form = this.fb.group({
      obs: [values ? values : null],
    });

    this.initializeTable();
  }

  verificateInput(value: string) {
    return (
      this.formTable.get(value)?.invalid &&
      (this.formTable.get(value)?.dirty || this.formTable.get(value)?.touched)
    );
  }

  addData() {
    if (this.formTable.invalid || this.submit) return;
    this.submit = true;
    this.tableValues.unshift(this.formTable.value);
    this.form.value.obs = this.tableValues;
    this.formTable.reset();
    this.initializeTable();
    this.taskCaseService
      .updateTaskCase(this.data.task._id, { data: this.tableValues }) //TODO colocar el last user
      .subscribe(
        (caseUpdated) => {
          this.formTable.reset();
          this.initializeTable();
          this.taskCaseService.taskUpdated.next({ task: caseUpdated });
          this.caseRecordService.updatedRecord.next(true);
        },
        (erorr) => {
          this.submit = false;
        }
      );
  }

  removerCuenta(index: number) {
    this.tableValues.splice(index, 1);
    this.taskCaseService
      .updateTaskCase(this.data.task.tareacasoId, { data: this.tableValues }) //TODO colocar el last user
      .subscribe((caseUpdated) => {
        this.initializeTable();
        this.taskCaseService.taskUpdated.next({ task: caseUpdated });
        this.caseRecordService.updatedRecord.next(true);
      });
  }

  initializeTable() {
    this.dataSource = new MatTableDataSource<InteraccionRedesSociales>(
      this.tableValues
    );
    this.dataSource.paginator = this.paginator;
    this.submit = false;
    this.submitFile = false;
  }
}
